import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslationService } from '../../../core/i18n/translation.service';
import { AISearchResults } from '../models/audit-assistant.model';

@Component({
  selector: 'app-audit-assistant-results',
  templateUrl: './audit-assistant-results.component.html',
  styleUrl: './audit-assistant-results.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditAssistantResultsComponent {
  readonly results = input.required<AISearchResults>();
  protected readonly i18n = inject(TranslationService);
  private readonly locale = computed(() => this.i18n.language() === 'pl' ? 'pl-PL' : 'en-GB');
  private readonly dateTimeFormatter = computed(() => new Intl.DateTimeFormat(this.locale(), {
    dateStyle: 'medium', timeStyle: 'short',
  }));
  // A plan is a calendar date, so changing the browser timezone must not shift its day.
  private readonly dateFormatter = computed(() => new Intl.DateTimeFormat(this.locale(), {
    dateStyle: 'medium', timeZone: 'UTC',
  }));
  protected dateTime(value: string): string { return this.dateTimeFormatter().format(new Date(value)); }
  protected date(value: string): string { return this.dateFormatter().format(new Date(`${value}T00:00:00Z`)); }
  protected role(value: string): string {
    return this.i18n.t(['AUDITOR', 'MANAGER', 'BUSINESS_ADMIN', 'SUPER_ADMIN'].includes(value)
      ? `auth.account.roles.${value}` : 'auditAssistant.results.unknownRole');
  }
}
